import apiHelper from '../helpers/apiHelper'

export default {
  get(page, searchId)
  {
    let additionalParams = ''
    page = (page ? parseInt(page) : '')
    searchId = (searchId ? parseInt(searchId) : '')
    if (page > 1 || searchId > 0)
    {
      additionalParams += (page ? 'page=' + page : '')
      additionalParams += (additionalParams ? '&' : '') + 'search=' + searchId
    }
    return apiHelper.request('referred-friends-contest' + (additionalParams ? ('/?' + additionalParams) : ''), {}, 'get', {}, true)
  }
}
